module.exports = __webpack_public_path__ + "static/footer-picture-crop-afef7e7f91e5cf83ce40f9b075106267.png";